## 👤 PROFESSIONAL SUMMARY

Full-stack developer with 10+ years of experience building and maintaining scalable web applications. Strong background in front-end architecture, UI component systems, and back-end services. Experienced with React, Node.js, relational and NoSQL databases, and Docker-based environments. Proven ability to design complex products end-to-end, refactor legacy codebases, and improve system reliability and maintainability.


## 🛠️ SKILLS

💻 Programming Languages: JavaScript, TypeScript, C#, PHP\
🎨 Front-End: React, Redux, Vue, HTML5, CSS3, Sass, Tailwind CSS\
⚙️ Back-End: Node.js, Express.js, ASP.NET, REST APIs, WebSocket\
🗄️ Databases: PostgreSQL, MySQL, MongoDB, MS SQL\
🔧 Tools & Platforms: Git, GitHub, Docker\
📦 Build & Tooling: Webpack, Vite\
✨ Other: UI architecture, component libraries, system refactoring

## 💼 WORK EXPERIENCE

### Full-Stack Developer

[Famiry](https://famiry.ru)\
09/2022 – Present

- Developed a reusable UI component library used across multiple products.
- Built a Notion-like rich text editor for managing structured user content.
- Implemented an interactive map with location search and geotagging features.
- Designed a back-end data backup service using queued processing.
- Developed real-time chat functionality with channels and file uploads.
- Built feed-based features for creating and sharing user stories.
- Implemented a photo album creation module.
- Performed large-scale refactoring and resolved complex bugs across the platform.

Technologies: React, Node.js, PostgreSQL, Docker

### Co-Founder & Full-Stack Developer

[Say Yes](https://sayyes.school)\
01/2015 – Present

- Designed and developed landing pages and internal web applications.
- Built and maintained a multi-module platform supporting core business operations.
- Implemented front-end logic and scalable back-end services.
- Participated in architectural decisions and long-term system evolution.

Technologies: React, Node.js, MongoDB

### Founder, Author & Full-Stack Developer

[CodeDojo](https://codedojo.io)\
01/2016 – 06/2022

- Founded and developed an online e-learning platform for programming education.
- Built front-end modules for browsing courses and educational content.
- Developed back-end services integrating user management and content delivery.
- Maintained and evolved the platform architecture over multiple iterations.

Technologies: React, Node.js, MongoDB


### 🎓 EDUCATION

**Gubkin Russian State University of Oil and Gas**\
09/2006 – 06/2011

Specialist Degree – Industrial Management

Diploma thesis: *Economic evaluation of field development project “Vostochno-Perevalnoye”, Khanty-Mansi Autonomous Okrug*


### 🏆 CERTIFICATIONS

**Microsoft Certified Professional**\
Exam 70-480: Programming in HTML5 with JavaScript and CSS3, 2016


### 🌍 LANGUAGES

🇷🇺 Russian – Native\
🇬🇧 English – Advanced (C1)\
🇪🇸 Spanish – Beginner